(function (jQuery) {
  jQuery.gfBackgroundSize = function (element, options) {
    const defaults = {
      onSelected: function () {},
    };

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;
    let _dataColumns = [];
    let _descriptionColumns = [];
    let _type;
    const _size = {
      width: '',
      height: '',
    };

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();

      if ($element.attr('data-value')) {
        _dataColumns = $element.attr('data-value').split(',');
      }
      if (_dataColumns == '') {
        _dataColumns = $element.attr('default_value').split(',');
      }
      if ($element.attr('data-tooltips')) {
        _descriptionColumns = $element.attr('data-tooltips').split(',');
      }

      _this.setTemplate();
      $element.on('value-change', function () {
        const value = $(this).val();
        _this.setValue(value);
      });
    };

    const _renderItem = function (item, index) {
      const width = 100 / _dataColumns.length;
      // Set Icon
      if (_descriptionColumns.length > 0) {
        var html =
          '<div data-value="' +
          item +
          '" class="gfSegmentItem" style="width:' +
          width +
          '%" ><div style="min-width:' +
          width +
          '%;" class="gfSegmentDescItem">' +
          _descriptionColumns[index] +
          '</div>' +
          item +
          '</div>';
      } else {
        var html =
          '<div data-value="' + item + '" class="gfSegmentItem" style="width:' + width + '%" >' + item + '</div>';
      }
      return html;
    };

    this.setTemplate = function () {
      let html = '';
      for (let i = 0; i < _dataColumns.length; i++) {
        html += _renderItem(_dataColumns[i], i);
      }
      let desc = '';
      if ($element.attr('data-description')) {
        desc = $element.attr('data-description');
      }

      const _template =
        '<div class="gfSegment"> <div class="gfSGSubTitle">' +
        _this.settings.title +
        '</div><div class="gfSGclear"></div><div class="gfSegmentContent">' +
        html +
        '</div> <div class="gfBackgroundSize"> <div class="gfBackgroundSizeLeft"> <div class="gfBackgroundSizeIcon"> <svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 15 5"> <path d="M12,5V3H3v2L0,2.5L3,0v2h9V0l3,2.5L12,5z" style="fill: rgba(255,255,255,0.8);" /> </svg> </div> <div class="gfBackgroundSizeInput"> <input type="text" /> <span>px</span> </div> </div> <div class="gfBackgroundSizeRight"> <div class="gfBackgroundSizeIcon"> <svg class="help-me-name-it-bruh" height="12px" viewBox="0 0 5 12"> <path d="M3,9h2l-2.5,3L0,9h2V3H0l2.5-3L5,3H3V9z" style="fill: rgba(255,255,255,0.8);" /> </svg> </div> <div class="gfBackgroundSizeInput"> <input type="text" /> <span>px</span> </div> </div> </div> <div class="gfDesc">' +
        desc +
        '</div> </div>';
      $element.after(_template);
      const $gfSegment = $element.next('.gfSegment');

      // Callback on Click
      const $buttonSegmentClick = $gfSegment.find('.gfSegmentItem');

      $buttonSegmentClick.click(function () {
        const item = $(this).attr('data-value');
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
        } else {
          $gfSegment.find('.gfSegmentItem').removeClass('active');
          $(this).addClass('active');
          //Change display;
          _type = item;
          _this.onChangeValue('change');
        }
      });
      const $sliderLeft = $gfSegment.find('.gfBackgroundSizeLeft input');
      const $sliderRight = $gfSegment.find('.gfBackgroundSizeRight input');
      $sliderLeft.off('mousedown.bg').on('mousedown.bg', function (e) {
        let $that = jQuery(this),
          start = e.pageY,
          end,
          old = parseInt($that.val()) || 0;

        const isDragging = true;

        $gfLeftSideBar.on('mousemove.bg', function (e) {
          end = e.pageY;
          const newVar = old + Math.floor((start - end) / 2);
          $that.val(newVar);
          _this.onChangeValue('change');
        });
        $gfLeftSideBar.on('mouseup.bg', function (e) {
          $gfLeftSideBar.off('mouseup.bg');
          $gfLeftSideBar.off('mousemove.bg');
        });
      });
      $sliderLeft.off('keyup change paste').on('keyup change paste', function () {
        _this.onChangeValue('change');
      });
      $sliderRight.off('mousedown.bg').on('mousedown.bg', function (e) {
        let $that = jQuery(this),
          start = e.pageY,
          end,
          old = parseInt($that.val()) || 0;

        const isDragging = true;

        $gfLeftSideBar.on('mousemove.bg', function (e) {
          end = e.pageY;
          const newVar = old + Math.floor((start - end) / 2);
          $that.val(newVar);
          _this.onChangeValue('change');
        });
        $gfLeftSideBar.on('mouseup.bg', function (e) {
          $gfLeftSideBar.off('mouseup.bg');
          $gfLeftSideBar.off('mousemove.bg');
        });
      });
      $sliderRight.off('keyup change paste').on('keyup change paste', function () {
        _this.onChangeValue('change');
      });

      return false;
    };

    _this.onChangeValue = function (type) {
      const $gfSegment = $element.next('.gfSegment');
      _size['width'] = $gfSegment.find('.gfBackgroundSizeLeft .gfBackgroundSizeInput input').val();
      _size['height'] = $gfSegment.find('.gfBackgroundSizeRight .gfBackgroundSizeInput input').val();

      if (type == 'change') {
        // triger
      }
    };

    this.setValue = function (value) {
      const $gfSegment = $element.next('gfSegment');
      $gfSegment.find('.gfSegmentItem').removeClass('active');
      $gfSegment.find('.gfSegmentItem[data-value="' + value + '"]').addClass('active');
      //Change display;
      _type = value;
      _this.onChangeValue('set');
      return false;
    };

    this.init();
  };
  jQuery.fn.gfBackgroundSize = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfbackgroundsize')) {
        const plugin = new jQuery.gfBackgroundSize(this, options);
        jQuery(this).data('gfbackgroundsize', plugin);
      }
    });
  };
})(jQuery);
